import { useEffect, useState } from 'react';
import { AuthLayout } from '../../layout';
import { ForgotPassword } from '../../features/reset';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { AuthBackgroundLayout } from '../../layout/auth/AuthBackgroundLayout';

const ForgotPage = () => {
  const [isEmbedded, setIsEmbedded] = useState(true);

  useEffect(() => {
    setIsEmbedded(window !== window.parent);
  }, []);

  if (isEmbedded) {
    return (
      <AuthBackgroundLayout>
        <ForgotPassword />
      </AuthBackgroundLayout>
    );
  }

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.FORGOT}>
      <AuthLayout>
        <ForgotPassword />
      </AuthLayout>
    </PageHelmet>
  );
};

export default ForgotPage;
